import { ISplitArray } from './array.service.interface';
import { Injectable } from '@angular/core';

/**
 * This service is a array service
 */
@Injectable()
export class ArrayService {
    /**
     * Splits an array in two
     *
     * @example
     * ArrayService.splitArray(Array<any>);
     *
     * param {Array<any>}
     * returns {object} { firstArray: Array<any>, secondArray: Array<any> }
     */
    splitArray(arr: Array<any>): ISplitArray {
        if (!Array.isArray(arr)) {
            console.error('It is not an array');

            return;
        }

        const mid = Math.ceil(arr.length / 2);
        const data: ISplitArray = {
            firstArray: [],
            secondArray: []
        };

        data.firstArray = arr.slice(0, mid);
        data.secondArray = arr.slice(mid);

        return data;
    }
}
